import React, { Component } from 'react'
import { default as data } from '../../_constants/requestedProducts'
import Checkbox from '../Shared/Checkbox'

class RequestedProductsSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      values: this.props.value || [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value })
    }
  }

  handleChange = (e) => {
    let values = this.state.values || [];

    let idx = values.indexOf(e);
    if (idx > -1) {
      values.splice(idx, 1)
    } else {
      values.push(e)
    }
    this.props.onChange(values)
  }

  render() {
    const { values } = this.state;

    return (
      <div className="row">
        {data.map((item, index) => (
          <div className="col-md-3 col-sm-12" key={index}>
            <Checkbox
              title={item.label}
              className="material-ui-checkbox"
              onChange={() => {
                this.handleChange(item.value)
              }
              }
              checked={values !== undefined && values.includes(item.value)}
            />
          </div>
        ))}
      </div>
    );
  }
}



export default RequestedProductsSelect;
